import { i18n } from '@/i18n'

export default [
  {
    id: 'site-template',
    icon: ['fad', 'palette'],
    name: i18n.t('site:template:name'),
    triggerLabel: i18n.t('site:template:trigger'),
    description: `<p>Vi tilbyr skreddersydde designmaler etter ditt ønske. Malen kan brukes på alle ønskelige prosjekter.</p><p>Har du en nettside fra før kan vi integrere denne med Kvass slik at du kan gjøre endringene på siden.</p>`,
    actionLabel: 'Ta kontakt',
    price: {
      value: 19000,
      type: 'from',
    },
  },
  {
    id: 'settlement',
    icon: ['fad', 'file-contract'],
    name: 'Oppgjørstjenester',
    description:
      'Oppgjørstjenester er for deg som ønsker et raskt og effektivt oppgjør foretatt av en profesjonell oppgjørsmegler med konsesjon fra Finanstilsynet.',
    triggerLabel: 'Ønsker du bistand med oppgjøret?',
    action: 'https://www.kvass.no/oppgjorstjenester/',
    price: {
      type: 'individual',
    },
  },
  {
    id: 'project-setup',
    icon: ['fad', 'cog'],
    name: 'Oppsett av prosjektside med boligvelger',
    triggerLabel: 'Ønsker du at vi setter det opp for deg?',
    description: 'Vi tilbyr å sette opp prosjektet for deg.',
    actionLabel: 'Ta kontakt',
    price: {
      type: 'individual',
    },
  },
  {
    id: 'domain',
    icon: ['fad', 'globe'],
    name: 'Oppsett av domene for prosjektet',
    triggerLabel: 'Trenger du bistand med oppsettet?',
    description: 'Vi tilbyr å sette opp domenet for deg. Dersom du ikke har et domene tilbyr vi også hosting av dette.',
    actionLabel: 'Ta kontakt',
    price: {
      type: 'individual',
    },
  },
  {
    id: 'contract',
    icon: ['fad', 'file-contract'],
    name: 'Oppsett av kontrakt for Kvass',
    triggerLabel: 'Jeg ønsker hjelp med oppsettet',
    description:
      'Vi tilbyr å sette opp datafeltene fra kontrakten din slik at Kvass automatisk kan fylle ut alle nødvendige felter.',
    actionLabel: 'Ta kontakt',
    price: {
      value: 1900,
      type: 'from',
    },
  },
  {
    id: 'contract-suggestion',
    icon: ['fad', 'file-contract'],
    name: 'Kontraktsforslag',
    action: 'https://www.kvass.no/oppgjorstjenester/',
    triggerLabel: 'Jeg trenger et kontraktsforslag',
    description: 'Vår samarbeidsparnter Megleroppgjøret AS skreddersyr en mal til deg som du kan bruke i Kvass.',
    price: {
      type: 'individual',
    },
  },
  {
    id: 'custom-fields',
    icon: ['fad', 'cog'],
    name: 'Ekstra felter',
    triggerLabel: 'Har du flere felter du ønsker å legge inn?',
    description:
      'Dersom du har behov for ekstra felter så anbefaler vi deg å bestille en unik designmal for prosjektet.',
    action: 'https://www.kvass.no/grafisk-materiell#designmal',
    price: {
      value: 19000,
      type: 'from',
    },
  },
  {
    id: 'shop',
    icon: ['fad', 'shopping-cart'],
    name: 'Tilvalgsbutikk',
    triggerLabel: 'Bestill tilvalgsbutikk',
    link: 'https://www.kvass.no/tilvalg/',
    description:
      'Denne modulen er for deg som ønsker å presentere og/ eller selge tilvalg digitalt. Disse modulene kan brukes på eksisterende prosjektsider i tillegg til prosjektsidene som lages i Kvass.',
    actionLabel: 'Bestill',
    price: {
      value: 1990,
      type: 'fromMonthly',
    },
  },
  {
    id: 'broker-integration',
    icon: ['fad', 'shopping-cart'],
    name: 'Integrasjon med meglersystemer ',
    triggerLabel: 'Bestill integrasjon',
    description:
      'En integrasjon med meglersystemet gjør det mulig å sende automatiske oppdateringer direkte til meglersystemet. På denne måten slipper du / din megler å oppdatere innhold flere steder.',
    actionLabel: 'Kontakt oss',
    price: {
      type: 'individual',
    },
  },
]
